module.exports = __webpack_public_path__ + "img/team-8.d02dec4.webp";